<template>
  <div class="mp3-tool">
    <img src="@/assets/image/zanting.png" class="audio-image" v-if="playStatus" alt="" @click="play()">
    <img src="@/assets/image/bofang.png" class="audio-image" v-else alt="" @click="play()">
    <div style="display: flex;align-items: center;">
      <el-select size="mini" v-model="playbackRate" placeholder="请选择" @change="changePlaybackRate">
        <el-option
          v-for="item in playbackRates"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
    </div>

    <div class="audio_container">
      <div class="audio_container_box">
        <div class="audio_container_box_jindu progress-container" @click="seek($event)">
          <div class="jindu" :style="{ width: scrollerwidth }"></div>
        </div>
        <div class="audio_container_box_time">{{ timeLength }}</div>
      </div>
    </div>
    <span v-if="audioError" class="audio-error" @click="play">音频加载失败，点击重试</span>
  </div>
</template>

<script>
export default {
  props: {
    srcUrl: {
      default: ""
    }
  },

  data() {
    return {
      audio:         null,
      playStatus:    false,//播放状态
      audioError:    false,
      loadingPromise: null,
      duration:      0,  //音频时长
      left:          0,//剩余时长
      scrollerwidth: "0%",      //进度条
      playbackRate: 1.0,
      playbackRates: [
        {
          label: 'x2.0',
          value: 2.0
        },
        {
          label: 'x1.5',
          value: 1.5
        },
        {
          label: 'x1.25',
          value: 1.25
        },
        {
          label: 'x1.0',
          value: 1.0
        },
        {
          label: 'x0.75',
          value: 0.75
        },
        {
          label: 'x0.5',
          value: .5
        }
      ]
    }
  },
  computed: {
    timeLength: {
      get() {
        return this.convertToTime(parseInt(this.left));
      },
      set(value) {
        return parseInt(value)
      }
    }
  },
  watch:    {
    left:   {
      handler(newValue) {
        this.timeLength = this.convertToTime(parseInt(newValue))
        this.scrollerwidth = this.computedPer()
      }
    },
    srcUrl: {
      handler() {
        this.initAudio()
      }
    }
  },

  created() {
    this.initAudio()
  },
  destroyed() {
    this.destroyAudio();
  },
  methods: {
    destroyAudio() {
      if (!this.audio) {
        this.duration = 0;
        this.left = 0;
        this.scrollerwidth = '0%';
        this.playStatus = false;
        return;
      }
      this.audio.removeEventListener('loadedmetadata', this.syncDuration);
      this.audio.removeEventListener('durationchange', this.syncDuration);
      this.audio.removeEventListener('canplay', this.syncDuration);
      this.audio.removeEventListener('timeupdate', this.syncProgress);
      this.audio.removeEventListener('play', this.handlePlay);
      this.audio.removeEventListener('pause', this.handlePause);
      this.audio.removeEventListener('ended', this.handleEnded);
      this.audio.removeEventListener('error', this.handleAudioError);
      this.audio.removeEventListener('stalled', this.handleAudioError);
      this.audio.removeEventListener('abort', this.handleAudioError);
      this.audio.pause();
      this.audio.src = '';
      this.audio.load();
      this.audio = null;
      this.duration = 0;
      this.left = 0;
      this.scrollerwidth = '0%';
      this.playStatus = false;
      this.audioError = false;
      this.loadingPromise = null;
    },
    handlePlay() {
      this.playStatus = true;
      this.audioError = false;
      this.$emit('showPlayStatus', this.playStatus);
    },
    handlePause() {
      this.playStatus = false;
      this.$emit('showPlayStatus', this.playStatus);
    },
    handleEnded() {
      this.playStatus = false;
      this.left = 0;
      this.scrollerwidth = '100%';
      this.$emit('showPlayStatus', this.playStatus);
    },
    handleAudioError() {
      this.playStatus = false;
      this.audioError = true;
      this.$emit('audioError', this.audio && this.audio.error);
      this.$emit('showPlayStatus', this.playStatus);
    },
    waitForReady() {
      if (!this.audio) return Promise.reject(new Error('audio is unavailable'));
      if (this.audio.readyState >= HTMLMediaElement.HAVE_FUTURE_DATA) {
        return Promise.resolve();
      }
      if (this.audio.error) return Promise.reject(this.audio.error);
      if (this.loadingPromise) return this.loadingPromise;
      this.loadingPromise = new Promise((resolve, reject) => {
        const onReady = () => {
          cleanup();
          resolve();
        };
        const onError = (event) => {
          cleanup();
          reject(event instanceof Event ? this.audio.error || event : event);
        };
        const cleanup = () => {
          this.audio.removeEventListener('canplay', onReady);
          this.audio.removeEventListener('error', onError);
          this.audio.removeEventListener('abort', onError);
        };
        this.audio.addEventListener('canplay', onReady, { once: true });
        this.audio.addEventListener('error', onError, { once: true });
        this.audio.addEventListener('abort', onError, { once: true });
        this.audio.load();
      }).finally(() => {
        this.loadingPromise = null;
      });
      return this.loadingPromise;
    },
    syncDuration() {
      if (!this.audio || !Number.isFinite(this.audio.duration)) {
        return;
      }
      this.duration = Math.max(Math.ceil(this.audio.duration), 0);
      this.left = Math.max(this.duration - this.audio.currentTime, 0);
      this.scrollerwidth = this.computedPer();
      this.$emit('showDuration', this.duration);
    },
    syncProgress() {
      if (!this.audio) {
        return;
      }
      const duration = Number.isFinite(this.audio.duration) ? this.audio.duration : this.duration;
      if (duration > 0) {
        this.duration = Math.max(Math.ceil(duration), 0);
        this.left = Math.max(duration - this.audio.currentTime, 0);
      } else {
        this.left = 0;
      }
      this.scrollerwidth = this.computedPer();
    },
    seek(event) {
      if (this.audio && this.duration > 0) {
        const progressContainer = this.$el.querySelector('.progress-container');
        const rect = progressContainer.getBoundingClientRect();
        const offsetX = event.clientX - rect.left;
        const width = rect.width;
        const newTime = (offsetX / width) * this.duration;
        this.audio.currentTime = newTime;
        this.syncProgress();
      }
    },
    changePlaybackRate() {
      if (this.audio) {
        this.audio.playbackRate = this.playbackRate;
      }
    },
    //初始化音频文件
    initAudio() {
      this.destroyAudio();
      if (this.srcUrl === "") {
        return;
      }
      const audio = new Audio();
      audio.preload = 'auto';
      audio.src = this.srcUrl;
      audio.playbackRate = this.playbackRate;
      audio.addEventListener('loadedmetadata', this.syncDuration);
      audio.addEventListener('durationchange', this.syncDuration);
      audio.addEventListener('canplay', this.syncDuration);
      audio.addEventListener('timeupdate', this.syncProgress);
      audio.addEventListener('play', this.handlePlay);
      audio.addEventListener('pause', this.handlePause);
      audio.addEventListener('ended', this.handleEnded);
      audio.addEventListener('error', this.handleAudioError);
      audio.addEventListener('stalled', this.handleAudioError);
      audio.addEventListener('abort', this.handleAudioError);
      audio.load();
      this.audio = audio;
      this.audioError = false;
    },
    //播放暂停
    play() {
      if (this.audio === null) {
        alert("请配置音频资源");
        return
      }
      if (this.playStatus) {
        this.audio.pause()
      } else {
        this.audio.playbackRate = this.playbackRate;
        this.audioError = false;
        this.waitForReady().then(() => this.audio.play()).then(() => {
          this.syncProgress();
        }).catch(() => {
          this.playStatus = false;
          this.audioError = true;
          this.$emit('showPlayStatus', this.playStatus);
        })
      }
    },
    //停止播放
    stop() {
      if (this.audio === null) {
        return
      }
      this.audio.pause()
      this.audio.currentTime = 0
      this.playStatus = false
      this.left = this.duration
      this.scrollerwidth = '0%'
      this.$emit("showPlayStatus", this.playStatus);
    },
    convertToTime(times) {
      if (typeof times === 'number') {
        if (times <= 0) {
          return '00:00:00';
        } else {
          let hh = parseInt(times / 3600); //小时
          let shh = times - hh * 3600;
          let ii = parseInt(shh / 60);
          let ss = shh - ii * 60;
          return (hh < 10 ? '0' + hh : hh) + ':' + (ii < 10 ? '0' + ii : ii) + ':' + (ss < 10 ? '0' + ss : ss);
        }
      } else {
        return '00:00:00';
      }
    },
    computedPer() {
      if (!this.duration) {
        return '0%';
      }
      let per = parseInt((this.duration - this.left) / this.duration * 100)
      return per + "%";
    }
  }
}
;
</script>
<style scoped>
.mp3-tool {
  display: flex;
}

.audio-image {
  width: 45px;
  height: 45px;
  margin-right: 10px;
}

.audio_container {
  padding-left: 20px;
  width: 100%;
}

.audio_container_box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
}

.audio_container_box_jindu {
  width: 100%;
  height: 6px;
  border-radius: 5px;
  overflow: hidden;
  background: rgba(238, 238, 238, 1);
  margin-right: 10px;
}

.jindu {
  height: 100%;
  border-radius: 5px;
  background: rgba(246, 112, 75, 1);
  transition-duration: 1s;
}

.audio_container_box_time {
  margin-right: 10px;
}
.audio-error {
  color: #d9534f;
  cursor: pointer;
  white-space: nowrap;
}
.el-select {
  width: 80px;
}
</style>
